<template>
    <div>
        <e-dialog
                dialogTitle="选择易物流运力"
                :centerDialogVisible="transportCapabilityVisible"
                @updateVisible="resetPopupData"
                @resetPopupData="resetPopupData"
                @submitPopupData="submitPopupData"
                :popupWidth="'600px'"
                :appendToBody="false">
            <div class="margin-l10 flex-c margin-t10">
                <el-form :inline="true" :model="formInline" ref="form" class="demo-form-inline" :rules="rules">
                    <el-form-item label="送货人" prop="deliPhone">
                        <el-select v-model="formInline.deliPhone" placeholder="请选择送货人" style="width: 200px;" @change="driverChange">
                            <el-option
                                    v-for="item in driverList"
                                    :key="item.phone"
                                    :label="item.driver"
                                    :value="item.phone">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="车牌号" prop="licensePlateNumber">
                        <el-select v-model="formInline.licensePlateNumber" placeholder="请选择车牌号" style="width: 200px;">
                            <el-option
                                    v-for="item in carList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </e-dialog>
    </div>
</template>

<script>
  import eDialog from "../../../components/common/e-dialog";
  import logisticsApi from "../../../api/logistics";
  export default {
    name: "transportCapabilityDialog",
    components:{eDialog},
    props:{
      transportCapabilityVisible:Boolean
    },
    data(){
      return{
        formInline:{
          deliName:'',//司机姓名
          deliPhone:'',//司机手机号码
          licensePlateNumber:''
        },
        carList: [],
        driverList:[],
        rules:{
          deliPhone: [{required: true, message: '请选择送货人', trigger: 'change',},],
          licensePlateNumber: [{required: true, message: '请选择车牌号', trigger: 'change',},],
        },
      }
    },
    methods:{
      resetPopupData(){
        this.$emit('closeDialog');
      },
      submitPopupData(){
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            this.$emit('chooseTransport',this.formInline);
          }
        })
      },
      driverChange(val){
        const driverData = this.driverList.filter(item=>item.phone === val);
         if(driverData.length > 0){
          this.formInline.deliName = driverData[0].driver;
        }
      },
      async getDrivers(){
        const res = await logisticsApi.getDrivers();
        if (res.success) {
          res.data.carList.forEach(item=>{
            this.carList.push({value:item,label:item});
          })
            this.driverList = res.data.driverList;
        }
      },
    },
    mounted() {
      this.getDrivers();
    }
  }
</script>

<style scoped>

</style>